import { mdiCalendarAccount } from '@mdi/js'
import Icon from '@mdi/react'
import { locales } from '../../locales/en'

const Calendar = (props) => (
    <Icon
        data-testid="IconButton__CalendarButton"
        title={locales.modelTile.age}
        path={mdiCalendarAccount}
        size={1}
        {...props}
    />
)

export default Calendar
